import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SpinnerService } from '../../_components/spinner/spinner.service';
import { MessageService } from 'primeng/api';
import { Constants } from '../Constants';
import { AuthService } from '../../_services';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private auth: AuthService,
    private spinner: SpinnerService,
    private message: MessageService,
    private translate: TranslateService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        const error = err.error?.message || err.error?.status || err.error;

        if (error === 'Token expired') {
          this.auth.SignOut();
        }

        this.spinner.hide();
        this.showErrorNotification(err);
        return throwError(() => error);
      })
    );
  }

  private showErrorNotification(err: HttpErrorResponse): void {
    // Handle both direct error object and nested error object
    const errorCode = err.error?.code || err.error?.error?.code;
    const errorMessage = err.error?.message || err.error?.error?.message;
    const errorParams = err.error?.params || err.error?.error?.params;

    if (errorCode) {
      this.message.add({
        severity: 'error',
        summary: this.translate.instant('errors.error_title'),
        detail: this.translate.instant(
          Constants.ErrorMessages.getTranslationKey(errorCode),
          errorParams
        ),
      });
    } else {
      this.message.add({
        severity: 'error',
        summary: this.translate.instant('errors.error_title'),
        detail: errorMessage,
      });
    }
  }
}
